import React from "react";
import { Check, X } from "lucide-react";
import { Reveal, Kicker, CTAButton, Section } from "@/components/landing/kit";
import { PATHS } from "@/lib/site-data";

const ThreePaths = () => (
  <Section id="paths" className="bg-[#F4F6FB] py-24 sm:py-32">
    <Reveal className="mx-auto mb-16 max-w-3xl text-center">
      <Kicker className="mb-5 justify-center">You have three options</Kicker>
      <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
        Three ways to run a store. Only one is truly hands-off.
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      {PATHS.map((path, i) => (
        <Reveal
          key={path.name}
          delay={i * 0.1}
          className={`relative flex flex-col rounded-3xl p-8 ${
            path.highlight
              ? "border-2 border-[#2D5BFF] bg-white shadow-[0_12px_40px_-10px_rgba(45,91,255,0.22)] ring-4 ring-[#2D5BFF]/10"
              : "border border-[#E5E8F0] bg-white shadow-sm"
          }`}
        >
          {path.highlight && (
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#2D5BFF] px-4 py-1 font-heading text-[11px] font-bold uppercase tracking-widest text-white">
              The only logical choice
            </span>
          )}
          <h3
            className={`font-heading text-2xl font-black uppercase tracking-tight ${
              path.highlight ? "text-[#0F1117]" : "text-[#5B6375]"
            }`}
          >
            {path.name}
          </h3>
          <p className="mt-1 text-sm font-medium text-[#858D9E]">{path.price}</p>

          <ul className="mt-8 flex-1 space-y-4">
            {path.points.map((pt) => (
              <li key={pt.text} className="flex items-start gap-3">
                <span
                  className={`mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                    pt.ok ? "bg-[#2D5BFF]/15 text-[#2D5BFF]" : "bg-slate-100 text-slate-400"
                  }`}
                >
                  {pt.ok ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />}
                </span>
                <span
                  className={`text-sm leading-snug ${
                    pt.ok ? "text-[#1E222D]" : "text-[#98A1B2] line-through decoration-slate-300"
                  }`}
                >
                  {pt.text}
                </span>
              </li>
            ))}
          </ul>

          {path.highlight && (
            <div className="mt-8">
              <CTAButton size="md" className="w-full" testId="paths-cta-button">
                Choose DSA
              </CTAButton>
            </div>
          )}
        </Reveal>
      ))}
    </div>
  </Section>
);

export default ThreePaths;
